import {useForm} from "../../../Commons/Scripts/Hooks/useForm";
import {UrlReporte, useImprimir} from "../../../Commons/Scripts/Hooks/useImprimir";
import {SimpleForm} from "../../../Commons/Scripts/Componentes/Form";
import {SelectField} from "../../../Commons/Scripts/Componentes/SelectField";
import {CheckboxField} from "../../../Commons/Scripts/Componentes/CheckboxField";
import {DateField} from "../../../Commons/Scripts/Componentes/DateField";
import {Button2} from "../../../Commons/Scripts/Componentes/Button";
import {Message, useMessage} from "../../../Commons/Scripts/Componentes/Message";
import React, {useState, useEffect, useRef} from 'react';
import { DataTable, Column, Skeleton } from 'primereact';
import {CxcReporteService} from "../Services/cxc-reporte-service";
import {FechaUtils} from "../../../Commons/Scripts/Utils/fechaUtils";
import {formatear2Decimales} from "../../../Commons/Scripts/Utils/formatear";
import { getLink } from "../../../Commons/Scripts/Utils/link";
import { useAuthentication } from '../../../Commons/Scripts/Hooks';
import { PAIS_CODIGO_DO, PAIS_CODIGO_EC, PAIS_CODIGO_CR } from '../../../Commons/Scripts/Utils/constants';

const origin = window.location.origin;

function OcultarCero({ children, valor }) {
  return <React.Fragment>{valor === 0 ? null : <span>{children}</span>}</React.Fragment>;
}

const BodyCliente = (data, field, setExpandedRows, esNumero = false) => {
  return (
    <div
      style={{ width: "100%", cursor: "pointer" }}
      onClick={() => {
        const key = data.ClienteId;

        setExpandedRows((prev) => {
          if (prev?.some((p) => p.ClienteId === key)) {
            return prev?.filter((p) => p.ClienteId !== key);
          } else {
            return [...(prev || []), data];
          }
        });
      }}
    >
      {esNumero && <span>{formatear2Decimales(data[field])}</span>}
      {!esNumero && data[field]}
    </div>
  );
};

function TablaEstadoCuenta({ documentos, indice, loading, expandedRows, setExpandedRows }) {
  const { useRef } = React;

    const balanceFinal = useRef([]);

    const { usuario } = useAuthentication();
    const [internacionalData, setInternacionalData] = useState({
        NCFheader: "NCF",
    });

    useEffect(() => {
        switch (usuario?.Compania?.Internacional) {            
            case PAIS_CODIGO_DO:
            default:
                setInternacionalData({
                    NCFheader: "NCF"
                });
                break;

            case PAIS_CODIGO_EC:
                setInternacionalData({
                    NCFheader: "Comprobante"
                });
                break;
            case PAIS_CODIGO_CR:
                setInternacionalData({
                    NCFheader: "Comprobante"
                });
                break;
        }
    }, [usuario?.Compania?.Internacional]);

  const clientesObj = documentos?.reduce((acc, item) => {
    const key = item.ClienteId;
    if (!acc[key]) {
      acc[key] = {
        ClienteId: item.ClienteId,
        Nombre: item.Nombre,
        ClienteDocumento: item.ClienteDocumento,
        documentos: [],
      };
    }
    acc[key].documentos.push(item);
    return acc;
  }, {});

  const clientes = Object.values(clientesObj);

  if (documentos?.length > 0) {
    const monedas = [...new Set(documentos?.map((item) => item.MonedaNombre))];

    balanceFinal.current = Array.from(clientes.values())
      .map((cliente) => {
        const documentosCliente = documentos?.filter((d) => d.ClienteId === cliente.ClienteId);

        const balanceFinalCliente = monedas?.map((moneda) => {
          const filtroMoneda = documentosCliente?.filter((d) => d.MonedaNombre === moneda);

          const balanceFinal = filtroMoneda?.reduce((acc, item) => {
            const noIncluido =
              item.Tipo === "Recibo Aplicando Anticipo" || item.Tipo === "Recibo Aplicando Nota Crédito";

            if (!noIncluido) {
              acc += item.Monto;
            }

            return acc;
          }, filtroMoneda?.[0]?.BalanceInicial || 0);

          return {
            ClienteId: cliente.ClienteId,
            Moneda: moneda,
            MonedaSimbolo: filtroMoneda?.[0]?.MonedaSimbolo,
            BalanceFinal: balanceFinal,
          };
        });

        return balanceFinalCliente;
      })
      .flat();
  }

  const rowExpansionTemplate = (cliente) => {
    const monedas = [...new Set(documentos?.map((item) => item.MonedaNombre))];

    return (
      <div>
        {monedas?.length > 0 &&
          monedas?.map((moneda, index) => {
            const filtroMoneda = documentos?.filter((d) => d.MonedaNombre === moneda);

            const filtroCliente = filtroMoneda?.filter((d) => d.ClienteId === cliente.ClienteId);

            const balanceInicial = {
              Tipo: "Balance Inicial",
              MonedaSimbolo: filtroCliente?.[0]?.MonedaSimbolo,
              Balance: filtroCliente?.[0]?.BalanceInicial,
            };

            const datos = [balanceInicial, ...filtroCliente];

            const totalMonto = filtroCliente?.reduce((acc, item) => {
              const noIncluido =
                item.Tipo === "Recibo Aplicando Anticipo" || item.Tipo === "Recibo Aplicando Nota Crédito";

              if (!noIncluido) {
                acc += item.Monto;
              }

              return acc;
            }, 0);

            return (
              <div key={`${index}-${moneda}`}>
                {filtroCliente?.length > 0 && (
                  <React.Fragment>
                    <p>
                      Documentos en Moneda: <b>{moneda}</b>
                    </p>
                    <DataTable value={datos}>
                      <Column
                        body={(item) => {
                          if (item.Tipo === "Balance Inicial") {
                            return <span>{item.Tipo}</span>;
                          }

                          return (
                            <a className="link" href={getLink(item.Tipo, item.DocumentoIdSec)} target="_blank">
                              {item.Tipo}
                            </a>
                          );
                        }}
                        field="Tipo"
                        header="Documento"
                        footer="Balance Final"
                      />
                      <Column
                        body={(item) => (
                          <a className="link" href={getLink(item.Tipo, item.DocumentoIdSec)} target="_blank">
                            {item.DocumentoIdSec}
                          </a>
                        )}
                        headerClassName="alinear-derecha"
                        style={{ textAlign: "right" }}
                        field="DocumentoIdSec"
                        header="Id"
                      />
                      <Column
                        body={(item) => (
                          <a className="link" href={getLink(item.Tipo, item.DocumentoIdSec)} target="_blank">
                            {item.NCF}
                          </a>
                        )}
                        field="NCF"
                        header={internacionalData?.NCFheader || "NCF"}
                      />
                      <Column
                        body={(item) => {
                          return (
                            <span>
                              {item.DocumentoAplicado}
                              <span className="text-blue">{item.AnticipoAplicado}</span>
                            </span>
                          );
                        }}
                        field="DocumentoAplicado"
                        header="Doc. Aplicado"
                      />
                      <Column
                        body={(item) => {
                          const match = item?.Fecha?.match(/\d+/);
                          const fechaMilisegundos = match ? Number(match[0]) : null;

                          return <span>{item?.Fecha && new Date(fechaMilisegundos).toLocaleDateString()}</span>;
                        }}
                        headerClassName="alinear-derecha"
                        style={{ textAlign: "right" }}
                        header="Fecha"
                      />
                      <Column
                        headerClassName="alinear-derecha"
                        style={{ textAlign: "right" }}
                        body={(item) => {
                          const noIncluido =
                            item.Tipo === "Recibo Aplicando Anticipo" || item.Tipo === "Recibo Aplicando Nota Crédito";
                          const monto = item.Monto;

                          const numeroFormateado = formatear2Decimales(Math.abs(item.Monto));
                          const montoMostrar = noIncluido
                            ? `[${numeroFormateado}]`
                            : monto < 0
                            ? `(${numeroFormateado})`
                            : numeroFormateado;
                          const clases = `${!noIncluido && monto < 0 ? "text-red" : ""} ${
                            noIncluido ? "text-blue" : ""
                          }`;

                          return <span className={clases}>{item.Monto && montoMostrar}</span>;
                        }}
                        header="Monto"
                      />
                      <Column
                        headerClassName="alinear-derecha"
                        style={{ textAlign: "right" }}
                        body={(item) => {
                          const balance = item.Balance;

                          const numeroFormateado = formatear2Decimales(Math.abs(item.Balance));
                          const balanceMostrar = balance < 0 ? `(${numeroFormateado})` : numeroFormateado;
                          const clases = `${balance < 0 ? "text-red" : ""}`;

                          return <span className={clases}>{balanceMostrar}</span>;
                        }}
                        header="Balance"
                        footer={() => {
                          const total = balanceInicial?.Balance + totalMonto;

                          return (
                            <span>
                              {balanceInicial?.MonedaSimbolo} {formatear2Decimales(total)}
                            </span>
                          );
                        }}
                      />
                    </DataTable>
                  </React.Fragment>
                )}
              </div>
            );
          })}
      </div>
    );
  };

  return (
    <div>
      {documentos?.length > 0 && (
        <DataTable
          id="grid"
          value={clientes}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowExpansionTemplate={(item) => rowExpansionTemplate(item)}
        >
          <Column
            expander
            style={{ width: "45px" }}
            body={(rowData) => {
              const isExpanded = expandedRows?.some((p) => p.ClienteId === rowData.ClienteId);

              return (
                <div
                  onClick={() => {
                    const key = rowData.ClienteId;

                    setExpandedRows((prev) => {
                      if (prev?.some((p) => p.ClienteId === key)) {
                        return prev?.filter((p) => p.ClienteId !== key);
                      } else {
                        return [...(prev || []), rowData];
                      }
                    });
                  }}
                  className={`p-row-toggler ${isExpanded ? "expanded" : ""}`}
                >
                  <i className="pi pi-chevron-right"></i>
                </div>
              );
            }}
          />
          <Column
            headerClassName="alinear-derecha"
            style={{ textAlign: "right" }}
            body={(item) => BodyCliente(item, "ClienteId", setExpandedRows)}
            field="ClienteId"
            header="Id"
          />
          <Column body={(item) => BodyCliente(item, "Nombre", setExpandedRows)} field="Nombre" header="Cliente" />
          <Column
            body={(item) => BodyCliente(item, "ClienteDocumento", setExpandedRows)}
            field="ClienteDocumento"
            header="Documento"
          />
          <Column
            headerClassName="alinear-derecha"
            style={{ textAlign: "right" }}
            body={(item) => {
              const ultimoDocumentoPorMoneda = item?.documentos?.reduce((acc, item) => {
                const key = `${item.MonedaNombre}`;
                acc.set(key, item);
                return acc;
              }, new Map());

              const balanceFinal = Array.from(ultimoDocumentoPorMoneda.values());

              return (
                <div
                  style={{ width: "100%", cursor: "pointer" }}
                  onClick={() => {
                    const key = item.ClienteId;

                    setExpandedRows((prev) => {
                      if (prev?.some((p) => p.ClienteId === key)) {
                        return prev?.filter((p) => p.ClienteId !== key);
                      } else {
                        return [...(prev || []), item];
                      }
                    });
                  }}
                >
                  {balanceFinal.map((data, i) => {
                    return (
                      <div key={`${i}`}>
                        {data?.MonedaSimbolo} {formatear2Decimales(data?.Balance)}
                      </div>
                    );
                  })}
                </div>
              );
            }}
            header="Balance Final"
          />
        </DataTable>
      )}

      {loading && indice === 1 && (
        <DataTable showHeaders={false} value={Array.from({ length: 30 })}>
          <Column body={<Skeleton style={{ height: "40px" }} />} />
        </DataTable>
      )}
    </div>
  );
}

function Formulario({
  clientes,
  tiposClientes,
  vendedores,
  tiendas,
  periodos,
  monedas,
  loadingDatos,
  onSubmit,
  valorInicial = {},
  onChange,
  where,
}) {
  const form = useForm(valorInicial);

  const [loadingPdf, handlePdf] = useImprimir(UrlReporte.ESTADO_CUENTA_CXC, "PDF");
  const [loadingExcel, handleExcel] = useImprimir(UrlReporte.ESTADO_CUENTA_CXC, "Excel");
  const [loadingCsv, handleCsv] = useImprimir(UrlReporte.ESTADO_CUENTA_CXC, "CSV");

  const handleSubmit = () => {
    onSubmit(form.values);
  };

  return (
    <SimpleForm formulario={form} onChange={onChange}>
      <div className="row">
        <SelectField
          isMulti
          name="cliente"
          opciones={clientes || []}
          label="Cliente"
          placeholder="Todos"
          isLoading={loadingDatos}
          width="400px"
        />
      </div>

      <div className="row">
        <SelectField
          name="tipoCliente"
          opciones={tiposClientes || []}
          placeholder="Todos"
          label="Tipo Cliente"
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
      </div>

      <div className="row">
        <div className="label"></div>
        <div className="control">
          <CheckboxField name="docPendientes" label="Documentos Pendientes" />
          <CheckboxField name="noMostrar" label="No Mostrar Documentos Por Aplicar" />
        </div>
      </div>

      <div className="row">
        <SelectField
          isMulti
          name="tienda"
          opciones={tiendas || []}
          label="Tienda"
          placeholder="Todos"
          isLoading={loadingDatos}
        />
      </div>

      <div className="row">
        <SelectField
          name="periodo"
          opciones={periodos || []}
          label="Periodo"
          placeholder="Seleccione un periodo"
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
      </div>

      <div className="row">
        <DateField name="fechaInicio" label="Fecha Inicio" mostrarIcono={true} />
        <DateField name="fechaFin" label="Fecha Fin" mostrarIcono={true} />
      </div>

      <div className="row">
        <SelectField
          name="moneda"
          opciones={monedas || []}
          label="Moneda"
          placeholder="Todas"
          isLoading={loadingDatos}
          opcionPorDefecto={true}
        />
      </div>

      <div
        style={{
          display: "flex",
          gap: "0 5px",
          margin: "10px 0 10px 125px",
        }}
      >
        <Button2 texto="Buscar" icono="buscar" onClick={handleSubmit} />
        <Button2 texto="PDF" icono="imprimir" loading={loadingPdf} onClick={() => handlePdf(where)} />
        <Button2 texto="Excel" icono="excel" loading={loadingExcel} onClick={() => handleExcel(where)} />
        <Button2 texto="CSV" icono="excel" loading={loadingCsv} onClick={() => handleCsv(where)} />
      </div>
    </SimpleForm>
  );
}

export function EstadoResultado() {
  const { messages, typeMessages, handleException, clearMessages } = useMessage();

  const [expandedRows, setExpandedRows] = useState(null);

  const [loading, setLoading] = useState(false);
  const [documentos, setDocumentos] = useState([]);
  const [total, setTotal] = useState(0);

  const [loadingDatos, setLoadingDatos] = useState(false);
  const [clientes, setClientes] = useState();
  const [tiposClientes, setTiposClientes] = useState();
  const [tiendas, setTiendas] = useState();
  const [periodos, setPeriodos] = useState();
  const [monedas, setMonedas] = useState();

  const [where, setWhere] = useState({
    FechaInicio: FechaUtils.getSeisMesesAntes(),
    FechaFin: FechaUtils.getHoyFin(),
    IndiceDePagina: 0,
    CantidadPorPagina: 50,
  });

  const totalPaginas = Math.ceil(total / where.CantidadPorPagina);
  const indice = (where.IndiceDePagina ?? 0) + 1;

  useEffect(() => {
    setLoading(true);
    clearMessages();

    CxcReporteService.consultarEstadoCuenta(where)
      .then((res) => {
          setDocumentos((prevDocumentos) => {
              const idsExistentes = new Set(prevDocumentos.map(d => d.DocumentoIdSec));
              const nuevosUnicos = (res?.Resultados || []).filter(d => !idsExistentes.has(d.DocumentoIdSec));
              return [...prevDocumentos, ...nuevosUnicos];
          });
          setTotal(res?.Total ?? 0);
      })
      .catch((err) => {
        handleException(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [where]);

  useEffect(() => {
    setLoadingDatos(true);
    clearMessages();

    Promise.all([
      CxcReporteService.consultarClientes(),
      CxcReporteService.consultarTiposClientes(),
      CxcReporteService.consultarTiendas(),
      CxcReporteService.consultarPeriodos(),
      CxcReporteService.consultarMonedas(),
    ])
      .then((res) => {
        const clientes = res[0]?.map((cliente) => {
          return {
            value: cliente.IdSec,
            label: cliente.Nombre,
          };
        });
        const tiposClientes = res[1]?.map((tipoCliente) => {
          return {
            value: tipoCliente.IdSec,
            label: tipoCliente.Nombre,
          };
        });
        const tiendas = res[2]?.map((tienda) => {
          return {
            value: tienda.IdSec,
            label: tienda.Nombre,
          };
        });
        const periodos = res[3]?.map((periodo) => {
          return {
            value: periodo.Value,
            label: periodo.Label,
          };
        });
        const monedas = res[4]?.map((moneda) => {
          return {
            value: moneda.IdSec,
            label: moneda.Descripcion,
          };
        });

        setClientes(clientes);
        setTiposClientes(tiposClientes);
        setTiendas(tiendas);
        setPeriodos(periodos);
        setMonedas(monedas);
      })
      .catch((error) => {
        handleException(error);
      })
      .finally(() => {
        setLoadingDatos(false);
      });
  }, []);

  const handleFiltrar = (filtros) => {
    setDocumentos([]);
    setTotal(0);
    setWhere({
      ...filtros,
      IndiceDePagina: 0,
      CantidadPorPagina: 50,
    });
  };

  const handleMostrarMas = () => {
    setWhere((prevWhere) => ({
      ...prevWhere,
      IndiceDePagina: prevWhere.IndiceDePagina + 1,
    }));
  };

  return (
    <React.Fragment>
      <Message messages={messages} type={typeMessages} />
      <Formulario
        clientes={clientes}
        tiposClientes={tiposClientes}
        tiendas={tiendas}
        periodos={periodos}
        monedas={monedas}
        loadingDatos={loadingDatos}
        onSubmit={(formulario) => {
          let fechaFin = new Date(formulario.fechaFin);
          const ahora = new Date();
          fechaFin.setHours(ahora.getHours(), ahora.getMinutes(), ahora.getSeconds(), ahora.getMilliseconds());

          const filtros = {
            ClienteIdSecList: formulario.cliente?.map((cliente) => cliente.value),
            FacturaEsProforma: formulario.factura?.value === "true",
            TipoClienteIdSec: formulario.tipoCliente?.value != "-1" ? formulario.tipoCliente?.value : null,
            SoloDocumentosPendientes: formulario.docPendientes,
            NoMostrarDocumentosPorAplicar: formulario.noMostrar,
            TiendaIdSecList: formulario.tienda?.map((tienda) => tienda.value),
            FechaInicio: formulario.fechaInicio,
            FechaFin: fechaFin,
            Periodo: formulario.periodo?.value != "-1" ? formulario.periodo?.value : null,
            MonedaIdSec: formulario.moneda?.value != "-1" ? formulario.moneda?.value : null,
          };

          handleFiltrar(filtros);
        }}
        valorInicial={{
          fechaInicio: FechaUtils.getSeisMesesAntes(),
          fechaFin: FechaUtils.getHoyFin(),
        }}
        onChange={(formulario) => {}}
        where={where}
      />
      <TablaEstadoCuenta
        documentos={documentos}
        indice={indice}
        loading={loading}
        expandedRows={expandedRows}
        setExpandedRows={setExpandedRows}
      />
      {indice < totalPaginas && (
        <Button2 loading={loading} onClick={handleMostrarMas} texto={loading ? "Cargando..." : "Mostrar más"} />
      )}
    </React.Fragment>
  );
}
